import {
  ApartmentOutlined,
  BarChartOutlined,
  CalendarOutlined,
  CommentOutlined,
  CopyOutlined,
  FileDoneOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  HomeOutlined,
  PieChartOutlined,
  ProfileOutlined,
  SolutionOutlined,
} from '@ant-design/icons'
import { Badge, Menu } from 'antd'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import React, { memo, useEffect, useLayoutEffect, useState } from 'react'
import { Link, useLocation, withRouter } from 'react-router-dom'
import { systemName } from '../../config'
import {
  ACL_ACTION_TYPE,
  MODULE_CODE,
  VAN_PHONG_DIEN_TU,
} from '../../constants'
import './index.css'

const sortCommands = (a, b) => {
  const nameA = a.name.toUpperCase()
  const nameB = b.name.toUpperCase()
  let comparison = 0
  if (nameA > nameB) {
    comparison = 1
  } else if (nameA < nameB) {
    comparison = -1
  }
  return comparison
}

const renderMenuIcon = (Icon, to) =>
  to ? (
    <Link
      to={to}
      className="menu-item-icon-link"
      onClick={e => e.stopPropagation()}>
      <Icon className="menu-item-icon" />
    </Link>
  ) : (
    <Icon className="menu-item-icon" />
  )

const getMenuTitleWithBadge = (titleText, count, isCollapsed = false) => {
  const numCount = Number(count) || 0
  if (isCollapsed) return titleText;
  return (
    <span className="ant-menu-title-content" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span className="menu-item-text" style={{ flex: '0 1 auto' }}>
        {titleText}
      </span>
      {numCount > 0 && (
        <span
          style={{
            backgroundColor: '#00b2ff',
            color: '#fff',
            borderRadius: '10px',
            padding: '0 6px',
            fontSize: '10px',
            lineHeight: '16px',
            height: '16px',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '16px',
            flexShrink: 0,
          }}>
          {numCount > 9 ? '9+' : numCount}
        </span>
      )}
    </span>
  )
}

// Giữ trạng thái sidebar qua các lần remount (chuyển trang remount MainSidebar).
let savedSidebarScrollTop = 0
let hasSidebarInitialized = false

const ALL_SUBMENU_KEYS = [
  'missions',
  'works',
  'TextDistributionProductsPageStore',
  'HDQT-group',
  'salary',
  'risk',
  'proposal',
  'utilities',
  'management',
  'connected-document',
]

// Trạng thái đóng/mở submenu, mặc định mở hết.
let savedOpenKeys = ALL_SUBMENU_KEYS

const getScrollParent = el => {
  let parent = el?.parentElement
  while (parent) {
    const { overflowY } = window.getComputedStyle(parent)
    if (overflowY === 'auto' || overflowY === 'scroll') {
      return parent
    }
    parent = parent.parentElement
  }
  return null
}

const getActiveSubmenuKey = pathname => {
  if (pathname.includes('/dashboard')) return null
  if (
    pathname.includes('/internal-document/') ||
    pathname.includes('/connected-document/') ||
    pathname.includes('/connected-committee-document/') ||
    pathname.includes('/document-management')
  )
    return 'connected-document'
  if (
    pathname.includes('/mission') ||
    pathname.includes('/mission-group') ||
    pathname.includes('/mission-management')
  )
    return 'missions'
  if (pathname.includes('/works') || pathname.includes('/shopping-coupon'))
    return 'works'
  if (
    pathname.includes('/salary') ||
    pathname.includes('/my-salary') ||
    pathname.includes('/proposal-salary') ||
    pathname.includes('/time-management')
  )
    return 'salary'
  if (
    pathname.includes('/proposal') ||
    pathname.includes('/distribution-votes') ||
    pathname.includes('/manager-inventory') ||
    pathname.includes('/proposal-advance') ||
    pathname.includes('/administrative-management')
  )
    return 'proposal'
  if (pathname.includes('/risk') || pathname.includes('/report')) return 'risk'
  if (pathname.includes('/utility/')) return 'utilities'
  if (
    pathname.includes('/management/') ||
    pathname.includes('/acl') ||
    pathname.includes('/module') ||
    pathname.includes('/admin/')
  )
    return 'management'
  if (pathname.includes('/feedback-hdqt') || pathname.includes('/board-'))
    return 'HDQT-group'
  if (pathname.includes('/TextDistribution'))
    return 'TextDistributionProductsPageStore'
  return null
}

const MainSidebar = props => {
  const {
    // location,
    commandStore,
    accountStore,
    authenticationStore,
    commonStore,
    moduleStore,
    aclStore,
    notificationStore,
  } = props

  const { commandList, sideMenuCounter } = commandStore
  const { accountList } = accountStore
  const { currentUser, isAccountAdmin, isSuperAdmin } = authenticationStore
  const { collapsedMenu } = commonStore
  const { moduleList } = moduleStore
  const { aclActionsByUser } = aclStore
  const { unreadNewsCount } = notificationStore

  // const [moduleFlatList, setModuleFlatList] = useState([])
  const location = useLocation()
  // TODO
  useEffect(() => {
    commandStore.getSideMenuCounter([
      'WORK',
      'PROPOSAL',
      'INTERNAL_MESSAGE',
      'INCOMING',
      'OUTGOING',
      'DISTRIBUTE',
      'PROCUREMENT',
    ])
    authenticationStore.checkUserPasswordExpried()
  }, [location.pathname])

  useEffect(() => {
    const moduleFlatListConvert = []
    moduleList.forEach(item => {
      moduleFlatListConvert.push({
        ...toJS(item),
        sub_modules: null,
      })
      if (item.sub_modules?.length > 0) {
        item.sub_modules.forEach(el => {
          moduleFlatListConvert.push(toJS(el))
        })
      }
    })
    // setModuleFlatList(moduleFlatListConvert)
  }, [moduleList])

  const isAccessControl = (moduleCode, accessControlType) => {
    if (isSuperAdmin) return true
    if (!moduleStore.checkAccessModule(moduleCode)) return false
    if (accessControlType)
      return (
        isAccountAdmin ||
        !!aclActionsByUser.find(item => item.code === accessControlType)?.status
      )
    return true
  }

  const isCurrentUserHasCommand =
    currentUser?.commands && currentUser.commands.length !== 0

  const offsetMenuCounter = [20, 24]

  // Menu trang chủ
  const menuTrangChu = (
    <Menu.Item
      key={'/dashboard'}
      icon={renderMenuIcon(HomeOutlined, '/dashboard')}
      title="Trang chủ">
      <Link to={'/dashboard'}>Trang chủ</Link>
    </Menu.Item>
  )

  // Menu thông báo chung
  const thongBaoChung = (
    <Menu.Item
      key={'/general-notifications'}
      icon={renderMenuIcon(FileTextOutlined)}
      title="Thông báo chung">
      <Link to={'/general-notifications'} className="menu-item-with-badge">
        <span className="menu-item-text">Thông báo chung</span>
        {!!unreadNewsCount && (
          <Badge
            count={unreadNewsCount > 99 ? '99+' : unreadNewsCount}
            overflowCount={9}
            style={{ marginLeft: 8 }}
          />
        )}
      </Link>
    </Menu.Item>
  )

  const menuLichCoQuan = (
    <Menu.Item
      key={'/company-work-schedule'}
      icon={renderMenuIcon(CalendarOutlined, '/company-work-schedule')}
      title="Lịch cơ quan">
      <Link to={'/company-work-schedule'}>Lịch cơ quan</Link>
    </Menu.Item>
  )

  // Menu nhiệm vụ
  const menuNhiemVu = () => {
    let linkToMisson = '/mission'
    if (
      !aclStore.checkAccessControlAction(ACL_ACTION_TYPE.bang_tong_hop__MISSION)
    ) {
      linkToMisson = `/mission?PIC=${currentUser.username}&assignee[0]=assignee%3D${currentUser.username}%2CUSER%2CPIC%2Cunknown`
    }
    return (
      <Menu.SubMenu
        key={'missions'}
        icon={renderMenuIcon(ProfileOutlined)}
        title="Nhiệm vụ">
        <Menu.Item key="/mission" title="Nhiệm vụ">
          <Link to={linkToMisson}>Nhiệm vụ</Link>
        </Menu.Item>
        {aclStore.checkAccessControlAction(
          ACL_ACTION_TYPE.lanh_dao__MISSION
        ) && (
            <Menu.Item key="/mission-group" title="Lãnh đạo">
              <Link to={'/mission-group'}>Lãnh đạo</Link>
            </Menu.Item>
          )}
        {(isAccountAdmin || isSuperAdmin) && (
          <Menu.Item key={'/mission-management'} title="Quản trị">
            <Link to={'/mission-management'}>Quản trị</Link>
          </Menu.Item>
        )}
      </Menu.SubMenu>
    )
  }

  const determineKey = pathname => {
    switch (pathname) {
      case '/manager-inventory':
        return '/manager-inventory'
      case '/manager-inventory/inventory-asset':
        return '/manager-inventory/inventory-asset'
      case '/manager-inventory/manage-inventory-asset':
        return '/manager-inventory/manage-inventory-asset'
      default:
        return '/manager-inventory'
    }
  }

  // Menu công việc moi
  const workParent = moduleList.find(item => item.code === 'cong_viec')
  const menuCongViec = aclStore.checkAccessControlAction(
    ACL_ACTION_TYPE.menu_outside__WORK
  ) &&
    workParent?.status && (
      <Menu.SubMenu
        key={'works'}
        icon={renderMenuIcon(ApartmentOutlined)}
        title={getMenuTitleWithBadge(
          'Công việc',
          Number(sideMenuCounter?.work || 0) +
          Number(sideMenuCounter?.pending_shopping || 0),
          !collapsedMenu
        )}>
        {aclStore.checkAccessControlAction(ACL_ACTION_TYPE.menu__WORK) &&
          workParent?.sub_modules[0]?.status && (
            <Menu.Item key={'/works'} title="Công việc">
              <Link to={'/works'} className="menu-item-with-badge">
                <span className="menu-item-text">Công việc</span>
                {!!sideMenuCounter?.work && (
                  <Badge
                    count={sideMenuCounter?.work ?? 0}
                    overflowCount={9}
                    color={'blue'}
                    style={{ marginLeft: 8 }}
                  />
                )}
              </Link>
            </Menu.Item>
          )}
        {aclStore.checkAccessControlAction(
          ACL_ACTION_TYPE.menu__QUY_TRINH_MUA_SAM
        ) &&
          workParent?.sub_modules[1]?.status && (
            <Menu.Item
              key={
                props?.location?.pathname === '/shopping-coupon'
                  ? '/shopping-coupon'
                  : props?.location?.pathname.indexOf(
                    '/shopping-coupon/other/view/'
                  ) !== -1
                    ? props?.location?.pathname
                    : ''
              }
              title="Quy trình mua sắm">
              <Link to={'/shopping-coupon'} className="menu-item-with-badge">
                <span className="menu-item-text">Quy trình mua sắm</span>
                {!!sideMenuCounter?.shopping && (
                  <Badge
                    count={sideMenuCounter?.pending_shopping ?? 0}
                    overflowCount={9}
                    color={'blue'}
                    style={{ marginLeft: 8 }}
                  />
                )}
              </Link>
            </Menu.Item>
          )}
      </Menu.SubMenu>
    )

  const menuPhieuPhanPhatVanPhongPham = (
    <Menu.SubMenu
      key={'TextDistributionProductsPageStore'}
      title={getMenuTitleWithBadge(
        'Văn phòng phẩm',
        Number(sideMenuCounter?.unapproved_distribute_vote || 0),
        !collapsedMenu
      )}
      icon={renderMenuIcon(FileTextOutlined)}>
      {isAccessControl(
        MODULE_CODE.phieu_phan_phat_vpp,
        ACL_ACTION_TYPE.menu__PHAN_PHAT
      ) && (
          <Menu.Item
            key={
              props?.location?.pathname === '/distribution-votes'
                ? '/distribution-votes'
                : props?.location?.pathname.indexOf(
                  '/distribution-votes/other/view/'
                ) !== -1
                  ? props?.location?.pathname
                  : ''
            }
            title="Phiếu phân phát VPP">
            <Link to={'/distribution-votes'} className="menu-item-with-badge">
              <span className="menu-item-text">Phiếu phân phát VPP</span>

              {!!sideMenuCounter?.unapproved_distribute_vote && (
                <Badge
                  count={sideMenuCounter?.unapproved_distribute_vote ?? 0}
                  overflowCount={9}
                  color={'blue'}
                  style={{ marginLeft: 8 }}
                />
              )}
            </Link>
          </Menu.Item>
        )}
      {isAccessControl(
        MODULE_CODE.quan_ly_kho,
        ACL_ACTION_TYPE.menu__QUAN_LY_KHO
      ) && (
          <Menu.Item
            key={determineKey(props.location.pathname)}
            title="Quản lý kho">
            <Link to={'/manager-inventory/inventory-asset'}>Quản lý kho</Link>
          </Menu.Item>
        )}
    </Menu.SubMenu>
  )

  const menuHDQT = (isAccountAdmin ||
    isSuperAdmin ||
    isAccessControl(
      MODULE_CODE.hoi_dong_quan_tri,
      ACL_ACTION_TYPE.menu__HDQT
    )) && (
      <Menu.SubMenu
        title="Hội đồng quản trị"
        key="HDQT-group"
        icon={renderMenuIcon(FileDoneOutlined)}>
        <Menu.Item key="/feedback-hdqt" title="Lấy ý kiến HĐQT/ NĐ">
          <Link to="/feedback-hdqt">Lấy ý kiến HĐQT/ NĐD</Link>
        </Menu.Item>
        {isAccessControl(
          MODULE_CODE.hoi_dong_quan_tri,
          ACL_ACTION_TYPE.menu__BBNQ_HDQT
        ) && (
            <Menu.Item key="/board-resolution-minutes-hdqt" title="NQ/QĐ/VB, BB">
              <Link to="/board-resolution-minutes-hdqt">NQ/QĐ/VB, BB</Link>
            </Menu.Item>
          )}
        {isAccessControl(
          MODULE_CODE.hoi_dong_quan_tri,
          ACL_ACTION_TYPE.menu__BC_HDQT
        ) && (
            <Menu.Item key="/board-report" title="Báo cáo HĐQT">
              <Link to="/board-report">Báo cáo HĐQT</Link>
            </Menu.Item>
          )}
      </Menu.SubMenu>
    )

  // Menu Kpi
  const menuKpi = (
    <Menu.Item key={'/kpi'} icon={renderMenuIcon(FileTextOutlined)} title="KPI">
      <Link to={'/kpi'}>KPI</Link>
    </Menu.Item>
  )

  // Menu bảng lương

  const menuSalary = (
    <Menu.SubMenu
      key={'salary'}
      icon={renderMenuIcon(PieChartOutlined)}
      title="Bảng lương">
      {isAccessControl(
        MODULE_CODE.duyet_luong,
        ACL_ACTION_TYPE.menu__SALARY
      ) && (
          <>
            <Menu.Item key={'/proposal-salary-request'} title="Duyệt lương">
              <Link to={'/proposal-salary-request'}>Duyệt lương</Link>
            </Menu.Item>
          </>
        )}

      {isAccessControl(
        MODULE_CODE.luong_cua_toi,
        ACL_ACTION_TYPE.menu__MY_SALARY
      ) && (
          <Menu.Item key={'/my-salary'} title="Lương của tôi">
            <Link to={'/my-salary'}>Lương của tôi</Link>
          </Menu.Item>
        )}
      {isAccessControl(
        MODULE_CODE.duyet_luong,
        ACL_ACTION_TYPE.menu__SALARY
      ) && (
          <>
            <Menu.Item key={'/time-management'} title="Chấm công">
              <Link to={'/time-management'}>Danh sách chấm công</Link>
            </Menu.Item>
          </>
        )}
      {(isAccountAdmin || isSuperAdmin) && (
        <Menu.Item key={'/proposal-salary-management'} title="Quản trị">
          <Link to={'/proposal-salary-management'}>Quản trị</Link>
        </Menu.Item>
      )}
    </Menu.SubMenu>
  )
  //phieu rui ro
  const menuPhieuRuiRo = isAccessControl(
    MODULE_CODE.phieu_rui_ro,
    ACL_ACTION_TYPE.menu__PKS_RUI_RO
  ) && (
      <Menu.SubMenu
        key={'risk'}
        icon={renderMenuIcon(FileSearchOutlined)}
        title="Phiếu kiểm soát rủi ro">
        {isAccessControl(
          MODULE_CODE.phieu_rui_ro,
          ACL_ACTION_TYPE.menu__PKS_RUI_RO
        ) && (
            <Menu.Item key={'/risk'} title="Phiếu kiểm soát rủi ro">
              <Link to={'/risk'}>Phiếu kiểm soát rủi ro</Link>
            </Menu.Item>
          )}
        {isAccessControl(
          MODULE_CODE.phieu_rui_ro,
          ACL_ACTION_TYPE.baoCao__PKS_RUI_RO
        ) && (
            <Menu.Item key={'/report'} title="Chế độ báo cáo">
              <Link to={'/report'}>Chế độ báo cáo</Link>
            </Menu.Item>
          )}
        {(isAccountAdmin ||
          isSuperAdmin ||
          isAccessControl(
            MODULE_CODE.phieu_rui_ro,
            ACL_ACTION_TYPE.quanTri__PKS_RUI_RO
          )) && (
            <Menu.Item key={'/risk-template'} title="Quản trị loại rủi ro">
              <Link to={'/risk-template'}>Quản trị loại rủi ro</Link>
            </Menu.Item>
          )}
        {(isAccountAdmin ||
          isSuperAdmin ||
          isAccessControl(
            MODULE_CODE.phieu_rui_ro,
            ACL_ACTION_TYPE.access__PKS_RUI_RO
          )) && (
            <Menu.Item key={'/risk/risk-management'} title="Quyền xem phiếu">
              <Link to={'/risk/risk-management'}>Quyền xem phiếu</Link>
            </Menu.Item>
          )}
        {(isAccountAdmin ||
          isSuperAdmin ||
          isAccessControl(
            MODULE_CODE.phieu_rui_ro,
            ACL_ACTION_TYPE.create__baocao__PKS_RUI_RO
          )) && (
            <Menu.Item key={'/report/management'} title="Quyền tạo báo cáo">
              <Link to={'/report/management'}>Quyền tạo báo cáo</Link>
            </Menu.Item>
          )}
      </Menu.SubMenu>
    )
  // Menu Hành chính
  const menuHanhChinh = (
    <Menu.SubMenu
      key={'proposal'}
      icon={renderMenuIcon(CopyOutlined)}
      title={getMenuTitleWithBadge(
        'Hành chính',
        Number(sideMenuCounter?.proposal_other || 0) +
        Number(sideMenuCounter?.unapproved_distribute_vote || 0),
        !collapsedMenu
      )}>
      {isAccessControl(MODULE_CODE.sub_hanh_chinh) && (
        <Menu.Item key={'/proposal'} title="Hành chính">
          <Link to={'/proposal'} className="menu-item-with-badge">
            <span className="menu-item-text">Hành chính</span>
            {!!sideMenuCounter?.proposal_other && (
              <Badge
                count={sideMenuCounter?.proposal_other ?? 0}
                overflowCount={9}
                color={'blue'}
                style={{ marginLeft: 8 }}
              />
            )}
          </Link>
        </Menu.Item>
      )}
      {isAccessControl(
        MODULE_CODE.phieu_phan_phat_vpp,
        ACL_ACTION_TYPE.menu__PHAN_PHAT
      ) && (
          <Menu.Item
            key={
              props?.location?.pathname === '/distribution-votes'
                ? '/distribution-votes'
                : props?.location?.pathname.indexOf(
                  '/distribution-votes/other/view/'
                ) !== -1
                  ? props?.location?.pathname
                  : 'phieu_phan_phat_vpp'
            }
            title="Phiếu phân phát VPP">
            <Link to={'/distribution-votes'} className="menu-item-with-badge">
              <span className="menu-item-text">Phiếu phân phát VPP</span>
              {!!sideMenuCounter?.unapproved_distribute_vote && (
                <Badge
                  count={sideMenuCounter?.unapproved_distribute_vote ?? 0}
                  overflowCount={9}
                  color={'blue'}
                  style={{ marginLeft: 8 }}
                />
              )}
            </Link>
          </Menu.Item>
        )}
      {isAccessControl(
        MODULE_CODE.quan_ly_kho,
        ACL_ACTION_TYPE.menu__QUAN_LY_KHO
      ) && (
          <Menu.Item
            key={determineKey(props.location.pathname)}
            title="Quản lý kho">
            <Link to={'/manager-inventory/inventory-asset'}>Quản lý kho</Link>
          </Menu.Item>
        )}
      {isAccessControl(
        MODULE_CODE.tam_ung,
        ACL_ACTION_TYPE.menu__PROPOSAL_ADVANCE
      ) && (
          <Menu.Item key={'/proposal-advance'} title="Tạm ứng">
            <Link to={'/proposal-advance'}>Tạm ứng</Link>
          </Menu.Item>
        )}

      {(isAccountAdmin ||
        isSuperAdmin ||
        isAccessControl(
          MODULE_CODE.administration,
          ACL_ACTION_TYPE.administration_PROPOSAL
        )) && (
          <Menu.Item key={'/administrative-management'} title="Quản trị">
            <Link to={'/administrative-management'}>Quản trị</Link>
          </Menu.Item>
        )}
    </Menu.SubMenu>
  )

  // Menu Tiện ích
  const menuTienIch = (
    <Menu.SubMenu
      key={'utilities'}
      icon={renderMenuIcon(CommentOutlined)}
      title={getMenuTitleWithBadge(
        'Tiện ích',
        Number(sideMenuCounter?.unread_internal_message || 0),
        !collapsedMenu
      )}>
      <Menu.Item key={'/utility/contacts'} title="Danh bạ">
        <Link to={'/utility/contacts'}>Danh bạ</Link>
      </Menu.Item>

      {isAccessControl(
        MODULE_CODE.thong_bao_chung,
        ACL_ACTION_TYPE.menu__NEWS
      ) && (
          <Menu.Item
            key={'/utility/general-notifications'}
            title="Thông báo chung">
            <Link to={'/utility/general-notifications'}>Thông báo chung</Link>
          </Menu.Item>
        )}

      {isAccessControl(MODULE_CODE.tai_lieu_iso, ACL_ACTION_TYPE.menu__ISO) && (
        <Menu.Item key={'/utility/iso'} title="Tài liệu ISO">
          <Link to={'/utility/iso'}>Tài liệu ISO</Link>
        </Menu.Item>
      )}

      {isAccessControl(
        MODULE_CODE.vb_phap_che,
        ACL_ACTION_TYPE.menu__PHAP_CHE
      ) && (
          <Menu.Item key={'/utility/vbpc'} title="VB Pháp chế">
            <Link to={'/utility/vbpc'}>VB Pháp chế</Link>
          </Menu.Item>
        )}

      {isAccessControl(MODULE_CODE.ky_so, ACL_ACTION_TYPE.menu__KY_SO) && (
        <Menu.Item key={'/utility/digital-signature'} title="Ký sô điện tử">
          <Link to={'/utility/digital-signature'}>Ký sô điện tử</Link>
        </Menu.Item>
      )}

      {isAccessControl(
        MODULE_CODE.tin_nhan_lien_thong,
        ACL_ACTION_TYPE.menu__TIN_NHAN_LIEN_THONG
      ) && (
          <Menu.Item key={'/utility/messages'} title="Tin nhắn liên thông">
            <Link to={'/utility/messages'}>Tin nhắn liên thông</Link>
          </Menu.Item>
        )}

      {isAccessControl(
        MODULE_CODE.tin_nhan_noi_bo,
        ACL_ACTION_TYPE.menu__TIN_NHAN_NOI_BO
      ) && (
          <Menu.Item
            key={'/utility/internal-message/receive'}
            title="Tin nhắn nội bộ">
            <Link
              to={'/utility/internal-message/receive'}
              className="menu-item-with-badge">
              <span className="menu-item-text">Tin nhắn nội bộ</span>
              {!!sideMenuCounter?.unread_internal_message && (
                <Badge
                  count={sideMenuCounter?.unread_internal_message ?? 0}
                  overflowCount={9}
                  color={'blue'}
                  style={{ marginLeft: 8 }}
                />
              )}
            </Link>
          </Menu.Item>
        )}

      {isAccessControl(MODULE_CODE.kpi, ACL_ACTION_TYPE.menu__KPI) && (
        <Menu.Item key={'/kpi'}>
          <Link to={'/kpi'}>KPI</Link>
        </Menu.Item>
      )}
    </Menu.SubMenu>
  )

  const menuBaoCao = (
    <Menu.Item
      key={'/utility/bi'}
      icon={renderMenuIcon(BarChartOutlined, '/utility/bi')}
      title="Báo cáo">
      <Link to={'/utility/bi'}>Báo cáo</Link>
    </Menu.Item>
  )

  const menuModule = (
    <Menu.Item
      key={'/module'}
      icon={renderMenuIcon(SolutionOutlined)}
      title="Hệ thống">
      <Link to={'/module'}>Hệ thống</Link>
    </Menu.Item>
  )

  const menuACL = (
    <Menu.Item key={'/acl'} title="Phân quyền">
      <Link to={'/acl'}>Phân quyền</Link>
    </Menu.Item>
  )

  // Menu quản trị
  const menuQuanTri = (
    <Menu.SubMenu
      key={'management'}
      title="Quản trị"
      icon={renderMenuIcon(SolutionOutlined)}>
      {isSuperAdmin && menuModule}

      {isAccessControl(
        MODULE_CODE.phong_ban,
        ACL_ACTION_TYPE.menu__QUAN_LY_PHONG_BAN
      ) && (
          <Menu.Item key={'/management/department'} title="Phòng ban">
            <Link to={'/management/department'}>Phòng ban</Link>
          </Menu.Item>
        )}

      {isAccessControl(
        MODULE_CODE.chuc_danh,
        ACL_ACTION_TYPE.menu__CHUC_DANH
      ) && (
          <Menu.Item key={'/management/position'} title="Chức danh">
            <Link to={'/management/position'}>Chức danh</Link>
          </Menu.Item>
        )}

      {(isAccountAdmin || isSuperAdmin) && (
        <Menu.Item key={'/admin/user-account-management'} title="Tài khoản">
          <Link to={'/admin/user-account-management'}>Tài khoản</Link>
        </Menu.Item>
      )}

      {(isAccountAdmin || isSuperAdmin) && menuACL}

      {isAccessControl(
        MODULE_CODE.nhom_nguoi_dung,
        ACL_ACTION_TYPE.menu__NHOM_NGUOI_DUNG
      ) && (
          <Menu.Item key={'/management/group'} title="Nhóm người dùng">
            <Link to={'/management/group'}>Nhóm người dùng</Link>
          </Menu.Item>
        )}

      {isAccessControl(
        MODULE_CODE.tai_khoan_ky_so,
        ACL_ACTION_TYPE.menu__TAI_KHOAN_KY_SO
      ) && (
          <Menu.Item key={'/management/sign-account'} title="Tài khoản ký số">
            <Link to={'/management/sign-account'}>Tài khoản ký số</Link>
          </Menu.Item>
        )}

      {(isAccountAdmin || isSuperAdmin) && (
        <Menu.Item
          key={'/management/company-work-schedule'}
          title="Lịch cơ quan">
          <Link to={'/management/company-work-schedule'}>Lịch cơ quan</Link>
        </Menu.Item>
      )}
    </Menu.SubMenu>
  )

  const renderCommandMenu = item => {
    let linkToInternalDocument = '/dashboard'
    if (
      aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.tab_cau_hinh_vb__INTERNAL_DOCUMENT
      )
    ) {
      linkToInternalDocument =
        '/internal-document/config-document/document-books'
    }
    if (
      aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.tab_phat_hanh_vb__INTERNAL_DOCUMENT
      )
    ) {
      linkToInternalDocument = '/internal-document/sign-document'
    }
    if (
      aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.tab_vb_di__INTERNAL_DOCUMENT
      )
    ) {
      linkToInternalDocument = '/internal-document/outgoing-document'
    }
    if (
      aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.tab_vb_den__INTERNAL_DOCUMENT
      )
    ) {
      linkToInternalDocument = '/internal-document/incoming-document'
    }
    let linkToLTVB = '/dashboard'
    if (
      aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.tab_vb_di__LIEN_THONG_VB
      )
    ) {
      linkToLTVB = '/connected-document/outgoing-document'
    }
    if (
      aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.tab_vb_den__LIEN_THONG_VB
      )
    ) {
      linkToLTVB = '/connected-document/incoming-document'
    }
    let linkToUBQLV = '/dashboard'
    if (aclStore.checkAccessControlAction(ACL_ACTION_TYPE.tab_vb_di__UBQLV)) {
      linkToUBQLV = '/connected-committee-document/outgoing-document'
    }
    if (aclStore.checkAccessControlAction(ACL_ACTION_TYPE.tab_vb_den__UBQLV)) {
      linkToUBQLV = '/connected-committee-document/incoming-document'
    }
    switch (item.code) {
      case VAN_PHONG_DIEN_TU:
        return (
          <Menu.SubMenu
            key={'connected-document'}
            title={getMenuTitleWithBadge(
              'Văn bản',
              Number(sideMenuCounter?.unread_incoming || 0) +
              Number(sideMenuCounter?.unread_outgoing || 0),
              !collapsedMenu
            )}
            icon={renderMenuIcon(FileTextOutlined)}>
            {isAccessControl(
              MODULE_CODE.van_ban_noi_bo,
              ACL_ACTION_TYPE.menu__INTERNAL_DOCUMENT
            ) && (
                <Menu.Item
                  key={'/internal-document/incoming-document'}
                  title={`Văn bản ${systemName}`}>
                  <Link
                    to={linkToInternalDocument}
                    className="menu-item-with-badge">
                    <span className="menu-item-text">Văn bản {systemName}</span>
                    {!Number.isNaN(
                      sideMenuCounter?.unread_incoming +
                      sideMenuCounter?.unread_outgoing
                    ) && (
                        <Badge
                          count={
                            sideMenuCounter?.unread_incoming +
                            sideMenuCounter?.unread_outgoing
                          }
                          color={'blue'}
                          overflowCount={9}
                          style={{ marginLeft: 8 }}
                        />
                      )}
                  </Link>
                </Menu.Item>
              )}

            {isAccessControl(
              MODULE_CODE.lien_thong_van_ban,
              ACL_ACTION_TYPE.menu__LIEN_THONG_VB
            ) && (
                <Menu.Item
                  key={'/connected-document/incoming-document'}
                  title={`Liên thông văn bản ${systemName}`}>
                  <Link to={linkToLTVB}>Liên thông văn bản {systemName}</Link>
                </Menu.Item>
              )}

            {isAccessControl(
              MODULE_CODE.lien_thong_van_ban_ubqlv,
              ACL_ACTION_TYPE.menu__UBQLV
            ) && (
                <Menu.Item
                  key={'/connected-committee-document/incoming-document'}
                  title="Liên thông văn bản UBQLV">
                  <Link to={linkToUBQLV}>Liên thông văn bản UBQLV</Link>
                </Menu.Item>
              )}

            {(isAccountAdmin || isSuperAdmin) && (
              <Menu.Item key={'/document-management'} title="Quản trị">
                <Link to={'/document-management'}>Quản trị</Link>
              </Menu.Item>
            )}
          </Menu.SubMenu>
        )
      default:
        return null
    }
  }

  useEffect(() => {
    // Trang chủ
    if (location.pathname.includes('/dashboard')) {
      commonStore.setPage(['/dashboard'])
      // setOpenedSubMenu([])
      return
    }
    // Lịch cơ quan
    // if (location.pathname.includes('/company-work-schedule')) {
    //   commonStore.setPage(['/company-work-schedule'])
    //   // setOpenedSubMenu(['company-work-schedule'])
    //   return
    // }

    // Thông báo
    if (location.pathname.includes('/notification')) {
      commonStore.setPage(['/notification'])
      return
    }
    // Văn bản
    if (location.pathname.includes('/document-management/')) {
      commonStore.setPage(['/document-management'])
      // setOpenedSubMenu(['connected-document'])
      return
    }
    if (location.pathname.includes('/connected-document/')) {
      commonStore.setPage(['/connected-document/incoming-document'])
      // setOpenedSubMenu(['connected-document'])
      return
    }
    if (location.pathname.includes('/connected-committee-document/')) {
      commonStore.setPage(['/connected-committee-document/incoming-document'])
      // setOpenedSubMenu(['connected-document'])
      return
    }
    if (location.pathname.includes('/internal-document/')) {
      commonStore.setPage(['/internal-document/incoming-document'])
      // setOpenedSubMenu(['connected-document'])
      return
    }

    // Nhiệm vụ
    if (location.pathname.includes('/mission-group/')) {
      commonStore.setPage(['/mission-group/'])
      // setOpenedSubMenu(['missions'])
      return
    }
    if (location.pathname.includes('/mission-management/')) {
      commonStore.setPage(['/mission-management'])
      // setOpenedSubMenu(['missions'])
      return
    }
    // Công việc
    if (
      location.pathname.includes('/my-tasks') ||
      location.pathname.includes('/my-tasks/')
    ) {
      commonStore.setPage(['/my-tasks'])
      // setOpenedSubMenu([])
      return
    }
    // Bảng lương

    if (
      location.pathname.includes('/my-salary') ||
      location.pathname.includes('/my-salary/')
    ) {
      commonStore.setPage(['/my-salary'])
      // setOpenedSubMenu(['salary'])
      return
    }

    if (
      location.pathname.includes('/proposal-salary-management') ||
      location.pathname.includes('/proposal-salary-management/')
    ) {
      commonStore.setPage(['/proposal-salary-management'])
      // setOpenedSubMenu(['salary'])
      return
    }

    if (
      location.pathname.includes('/salary') ||
      location.pathname.includes('/salary/')
    ) {
      commonStore.setPage(['/salary'])
      // setOpenedSubMenu(['salary'])
      return
    }

    if (
      location.pathname.includes('/proposal-salary-request') ||
      location.pathname.includes('/proposal-salary-request/') ||
      location.pathname.includes('/time-management')
    ) {
      commonStore.setPage(['/proposal-salary-request'])
      // setOpenedSubMenu(['salary'])
      return
    }

    // Quản lý phân hệ
    if (
      location.pathname.includes('/module') ||
      location.pathname.includes('/module/')
    ) {
      commonStore.setPage(['/module'])
      // // setOpenedSubMenu([])
      return
    }
    // Quản lý phân quyền
    if (
      location.pathname.includes('/acl') ||
      location.pathname.includes('/acl/')
    ) {
      commonStore.setPage(['/acl'])
      // // setOpenedSubMenu([])
      return
    }
    if (
      location.pathname.includes('/works') ||
      location.pathname.includes('/works/')
    ) {
      commonStore.setPage(['/works'])
      // // setOpenedSubMenu([])
      return
    }
    // Quy trình
    if (
      location.pathname.includes('/administrative/consult') ||
      location.pathname.includes('/administrative/consult/')
    ) {
      commonStore.setPage(['/administrative/consult'])
      // setOpenedSubMenu(['administrative'])
      return
    }
    if (
      location.pathname.includes('/administrative/policy') ||
      location.pathname.includes('/administrative/policy/')
    ) {
      commonStore.setPage(['/administrative/policy'])
      // setOpenedSubMenu(['administrative'])
      return
    }
    if (
      location.pathname.includes('/administrative/advance-payment') ||
      location.pathname.includes('/administrative/advance-payment/')
    ) {
      commonStore.setPage(['/administrative/advance-payment'])
      // setOpenedSubMenu(['administrative'])
      return
    }
    if (location.pathname.includes('/administrative/payslip')) {
      commonStore.setPage(['/administrative/payslip'])
      // setOpenedSubMenu(['administrative'])
      return
    }
    // Hành chính
    if (
      location.pathname.includes('/proposal-advance') ||
      location.pathname.includes('/proposal-advance/')
    ) {
      commonStore.setPage(['/proposal-advance'])
      // setOpenedSubMenu(['proposal'])
      return
    }
    if (location.pathname.includes('/administrative-management/')) {
      commonStore.setPage(['/administrative-management'])
      // setOpenedSubMenu(['proposal'])
      return
    }
    if (
      location.pathname.includes('/proposal') ||
      location.pathname.includes('/proposal/')
    ) {
      commonStore.setPage(['/proposal'])
      // setOpenedSubMenu(['proposal'])
      return
    }

    // phiếu phân phát văn phòng phẩm
    if (
      location.pathname.includes('/text-distribution-products') ||
      location.pathname.includes('/text-distribution-products/')
    ) {
      commonStore.setPage(['/text-distribution-products'])
      // // setOpenedSubMenu([])
      return
    }

    // Tiện ích
    if (
      location.pathname.includes('/utility/iso') ||
      location.pathname.includes('/utility/iso/')
    ) {
      commonStore.setPage(['/utility/iso'])
      // setOpenedSubMenu(['utilities'])
      return
    }
    if (
      location.pathname.includes('/utility/vbpc') ||
      location.pathname.includes('/utility/vbpc/')
    ) {
      commonStore.setPage(['/utility/vbpc'])
      // setOpenedSubMenu(['utilities'])
      return
    }
    if (
      location.pathname.includes('/utility/messages') ||
      location.pathname.includes('/utility/messages/')
    ) {
      commonStore.setPage(['/utility/messages'])
      // setOpenedSubMenu(['utilities'])
      return
    }
    if (
      location.pathname.includes('/utility/signed-document') ||
      location.pathname.includes('/utility/signed-document/')
    ) {
      commonStore.setPage(['/utility/signed-document'])
      // setOpenedSubMenu(['utilities'])
      return
    }
    if (
      location.pathname.includes('/utility/contacts') ||
      location.pathname.includes('/utility/contacts/')
    ) {
      commonStore.setPage(['/utility/contacts'])
      // setOpenedSubMenu(['utilities'])
      return
    }
    if (
      location.pathname.includes('/utility/general-notifications') ||
      location.pathname.includes('/utility/general-notifications/')
    ) {
      commonStore.setPage(['/utility/general-notifications'])
      // setOpenedSubMenu(['utilities'])
      return
    }
    if (
      location.pathname.includes('/utility/digital-signature') ||
      location.pathname.includes('/utility/digital-signature/')
    ) {
      commonStore.setPage(['/utility/digital-signature'])
      // setOpenedSubMenu(['utilities'])
      return
    }
    // Quản trị

    if (location.pathname.includes('/management/group')) {
      commonStore.setPage(['/management/group'])
      // setOpenedSubMenu(['management'])
      return
    }
    if (location.pathname.includes('/management/nhiem-vu-group')) {
      commonStore.setPage(['/management/nhiem-vu-group'])
      // setOpenedSubMenu(['management'])
      return
    }

    if (location.pathname.includes('/management/document-books')) {
      commonStore.setPage(['/management/document-books'])
      // setOpenedSubMenu(['management'])
      return
    }
    if (location.pathname.includes('/management/sample-document')) {
      commonStore.setPage(['/management/sample-document'])
      // setOpenedSubMenu(['management'])
      return
    }
    if (location.pathname.includes('/management//management/sign-account')) {
      commonStore.setPage(['/management/sample-document'])
      // setOpenedSubMenu(['management'])
      return
    }
    if (location.pathname.includes('/management/company-work-schedule')) {
      commonStore.setPage(['/management/company-work-schedule'])
      // setOpenedSubMenu(['management'])
      return
    }
    commonStore.setPage([location.pathname])
  }, [location.pathname])

  useEffect(() => {
    if (isCurrentUserHasCommand) {
      currentUser.commands.forEach(userCommand => {
        commandList.length !== 0 &&
          commandList.forEach(command => {
            if (command.code === userCommand.code) {
              userCommand.url = command.url
              userCommand.description = command.description
              userCommand.image = command.image
            }
          })
        accountList.length !== 0 &&
          accountList.forEach(account => {
            if (account.command.code === userCommand.code) {
              userCommand.account_name = account.account_name
              userCommand.id = account.id
              userCommand.password = account.password
            }
          })
      })
    }
  }, [currentUser, commandList, accountList, isCurrentUserHasCommand])

  useLayoutEffect(() => {
    const menuEl = document.querySelector('.custom-main-sidebar')
    const scrollParent = getScrollParent(menuEl)
    if (!scrollParent) {
      return
    }

    let rafId = 0
    if (hasSidebarInitialized) {
      scrollParent.scrollTop = savedSidebarScrollTop
      rafId = window.requestAnimationFrame(() => {
        scrollParent.scrollTop = savedSidebarScrollTop
      })
    } else {
      hasSidebarInitialized = true
    }

    const handleScroll = () => {
      savedSidebarScrollTop = scrollParent.scrollTop
    }
    scrollParent.addEventListener('scroll', handleScroll, { passive: true })
    return () => {
      if (rafId) {
        window.cancelAnimationFrame(rafId)
      }
      scrollParent.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const [openKeys, setOpenKeys] = useState(savedOpenKeys)

  useEffect(() => {
    const activeKey = getActiveSubmenuKey(location.pathname)
    const nextOpenKeys = activeKey ? [activeKey] : []
    savedOpenKeys = nextOpenKeys
    setOpenKeys(nextOpenKeys)
  }, [location.pathname])

  const handleOpenChange = nextOpenKeys => {
    if (!collapsedMenu) {
      return
    }
    savedOpenKeys = nextOpenKeys
    setOpenKeys(nextOpenKeys)
  }

  return (
    <Menu
      mode="inline"
      className="custom-main-sidebar"
      selectedKeys={commonStore.pageName}
      inlineCollapsed={!collapsedMenu}
      openKeys={collapsedMenu ? openKeys : undefined}
      onOpenChange={handleOpenChange}>
      {aclStore.checkAccessControlAction(ACL_ACTION_TYPE.menu_HOME_PAGE) &&
        menuTrangChu}
      {/* {thongBaoChung} */}
      {isAccessControl(
        MODULE_CODE.lich_co_quan,
        ACL_ACTION_TYPE.menu__WORK_SCHEDULE
      ) && menuLichCoQuan}

      {
        //menu VPDT
        isAccessControl(MODULE_CODE.van_ban) &&
          aclStore.checkAccessControlAction(ACL_ACTION_TYPE.menu__VAN_BAN) &&
          isCurrentUserHasCommand
          ? currentUser.commands
            .slice()
            .sort(sortCommands)
            .map(item => renderCommandMenu(item))
          : null
      }

      {isAccessControl(MODULE_CODE.nhiem_vu, ACL_ACTION_TYPE.menu__MISSION) &&
        menuNhiemVu()}
      {/* {isAccessControl(MODULE_CODE.cong_viec, ACL_ACTION_TYPE.menu__WORK) &&
          } */}
      {menuCongViec}
      {isAccessControl(MODULE_CODE.bang_luong) &&
        aclStore.checkAccessControlAction(
          ACL_ACTION_TYPE.menu_outside__SALARY
        ) &&
        menuSalary}
      {isAccessControl(
        MODULE_CODE.hanh_chinh,
        ACL_ACTION_TYPE.menu__PROPOSAL
      ) && menuHanhChinh}
      {/* {isAccessControl(
          MODULE_CODE.ql_van_phong_pham,
          ACL_ACTION_TYPE.menu__PHAN_PHAT_VAN_PHONG_PHAM
        ) && menuPhieuPhanPhatVanPhongPham} */}
      {isAccessControl(MODULE_CODE.phieu_rui_ro) && menuPhieuRuiRo}
      {isAccessControl(MODULE_CODE.tien_ich) &&
        aclStore.checkAccessControlAction(ACL_ACTION_TYPE.menu__UTILITY) &&
        menuTienIch}
      {isAccessControl(MODULE_CODE.kpi, ACL_ACTION_TYPE.menu__BAO_CAO) &&
        menuBaoCao}
      {isAccessControl(MODULE_CODE.hoi_dong_quan_tri) && menuHDQT}
      {isAccessControl(MODULE_CODE.quan_tri) &&
        aclStore.checkAccessControlAction(ACL_ACTION_TYPE.menu__ADMIN) &&
        menuQuanTri}
    </Menu>
  )
}

export default memo(
  withRouter(
    inject(
      'commandStore',
      'accountStore',
      'authenticationStore',
      'commonStore',
      'loadingAnimationStore',
      'notificationStore',
      'moduleStore',
      'aclStore'
    )(observer(MainSidebar))
  )
)
